export class DTMultiselect {

    static init(parentClass, table) {
      this.updateDataTableSelectAllCtrl(parentClass);
      this.handleListeners(parentClass, $(`${table} tbody`), $(`${table} thead`))
    }
  
    static updateDataTableSelectAllCtrl(parentClass){
      let $table             = parentClass.table.table().node();
      let $chkbox_all        = $('tbody input[class="select_row"]', $table);
      let $chkbox_checked    = $('tbody input[class="select_row"]:checked', $table);
      let chkbox_select_all  = $('thead input[name="select_all"]', $table).get(0);
  
      // If none of the checkboxes are checked
      if($chkbox_checked.length === 0){
         chkbox_select_all.checked = false;
        // Method required in parent class
         parentClass.selectAllFalse();
        // jquery needed here to reach all pages
        parentClass.table.rows().every(function() {
          this.nodes().to$().removeClass('selected')
        })
         if('indeterminate' in chkbox_select_all){
            chkbox_select_all.indeterminate = false;
         }
         document.querySelector('#edit-dni-multi').setAttribute('disabled', 'disabled');
      // If all of the checkboxes are checked
      } else if ($chkbox_checked.length === $chkbox_all.length){
         chkbox_select_all.checked = true;
         // Method required in parent class
         parentClass.selectAllTrue();
        // jquery needed here to reach all pages
        parentClass.table.rows().every(function() {
          this.nodes().to$().addClass('selected')
        })
         if('indeterminate' in chkbox_select_all){
            chkbox_select_all.indeterminate = false;
         }
         document.querySelector('#edit-dni-multi').removeAttribute('disabled');
      // If some of the checkboxes are checked
      } else {
         chkbox_select_all.checked = true;
         // Method required in parent class
         parentClass.selectAllFalse();
         if('indeterminate' in chkbox_select_all){
            chkbox_select_all.indeterminate = true;
         }
         document.querySelector('#edit-dni-multi').removeAttribute('disabled');
      }
   }
  
   static handleListeners(parentClass, tbody, thead) {
    // Handle click on row selection checkbox
    $(tbody).on('click', 'input[class="select_row"]', function(e){
      let $row = $(e.target).closest('tr');
      // Get row data
      let data = parentClass.table.row($row).data();
      data['row_selected'] = e.target.checked;
      // Get row ID
      let rowId = data.dni_campaign_id;
  
      // Determine whether row ID is in the list of selected row IDs
      let index = $.inArray(rowId, rows_selected);
  
      // If checkbox is checked and row ID is not in list of selected row IDs
      if(e.target.checked && index == -1){
          rows_selected.push(rowId);
  
      // Otherwise, if checkbox is not checked and row ID is in list of selected row IDs
      } else if (!e.target.checked && index != -1){
          rows_selected.splice(index, 1);
      }
      if(e.target.checked){
        $row.addClass('selected');
      } else {
        $row.removeClass('selected');
      }
  
      // Update state of "Select all" control
      this.updateDataTableSelectAllCtrl(parentClass);
  
      // Prevent click event from propagating to parent
      e.stopPropagation();
    }.bind(this));
  
    // Handle click on "Select all" control
    $(thead).on('click', 'input[name="select_all"]', function(e){
      let data = parentClass.table.rows().data();
      for (let i=0; i < data.length; i++) {
        data[i]['row_selected'] = e.target.checked;
      }
      parentClass.table.rows().invalidate().draw();
      this.updateDataTableSelectAllCtrl(parentClass);
      // Prevent click event from propagating to parent
      e.stopPropagation();
    }.bind(this));
   }
};